/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Sanction_Mgr_Issue_ToInputs */



/**
* | output |
* | --- |
* | "Issue a sanction to {name}" |
*
* @param {Sanction_Mgr_Issue_ToInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_mgr_issue_to = /** @type {((inputs: Sanction_Mgr_Issue_ToInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Mgr_Issue_ToInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Émettre une sanction à ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Emitir una sanción a ${i?.name}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Emitir uma sanção para ${i?.name}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Emetti una sanzione a ${i?.name}`)
	return /** @type {LocalizedString} */ (`Issue a sanction to ${i?.name}`)
});